import axios, { AxiosAdapter, AxiosInstance } from 'axios';

import { store } from '../app/store';
import {
  _setLoginModalShown,
  _setLoginSessionExpired,
} from '../slices/uiSlice';
import { _resetState } from '../slices/userSlice';

const IS_DEMO_MODE = process.env.REACT_APP__MODE === 'demo';

const demoAdapter: AxiosAdapter = async (config) => {
  const { demoAdapter: adapter } = await import('./demo/adapter');
  return adapter(config);
};

export const axiosInstance: AxiosInstance = IS_DEMO_MODE
  ? axios.create({ adapter: demoAdapter })
  : axios.create();

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      store.dispatch(_resetState());
      store.dispatch(_setLoginSessionExpired(true));
      store.dispatch(_setLoginModalShown(true));
    }
    return Promise.reject(err);
  },
);
